import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Header from './components/Header';
import StatsCard from './components/StatsCard';
import DataTable from './components/DataTable';

// Profile photos mapping - same as other pages for consistency
const profilePhotos: { [key: string]: string } = {
  // AJ Santiago variations
  'aj': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  'aj santiago': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  'AJ': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  'AJ Santiago': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  // Adrian Medrano variations
  'adrian': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  'adrian medrano': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  'Adrian': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  'Adrian Medrano': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  // Alex/Alexander Lara variations
  'alex': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'alexander': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'alex lara': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'alexander lara': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'Alex': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'Alexander': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'Alex Lara': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'Alexander Lara': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  // Fernando Bochas variations
  'fernando': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  'fernando bochas': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  'Fernando': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  'Fernando Bochas': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  // Jeff/Jeffrey Wilson variations
  'jeff': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'jeffrey': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'jeff wilson': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'jeffrey wilson': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'Jeff': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'Jeffrey': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'Jeff Wilson': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'Jeffrey Wilson': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  // Jenny/Jennyrose Arvizu variations
  'jenny': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'jennyrose': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'jenny arvizu': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'jennyrose arvizu': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'Jenny': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'Jennyrose': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'Jenny Arvizu': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'Jennyrose Arvizu': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  // Jesse Cheguina variations
  'jesse': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  'jesse cheguina': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  'Jesse': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  'Jesse Cheguina': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  // Paul Sims variations
  'paul': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  'paul sims': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  'Paul': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  'Paul Sims': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  // Shan/Shanitan Harrell variations
  'shan': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'shanitan': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'shan harrell': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'shanitan harrell': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'Shan': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'Shanitan': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'Shan Harrell': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'Shanitan Harrell': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  // Steven Simpson variations
  'steven': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  'steven simpson': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  'Steven': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  'Steven Simpson': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  // Yesenia Pena variations
  'yesenia': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  'yesenia pena': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  'Yesenia': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  'Yesenia Pena': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  // Yulisa Pena variations
  'yulisa': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png',
  'yulisa pena': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png',
  'Yulisa': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png',
  'Yulisa Pena': 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png'
};

// Function to get profile photo
const getProfilePhoto = (employeeName: string): string | null => {
  if (!employeeName || typeof employeeName !== 'string') {
    return null;
  }

  // Try exact match first
  if (profilePhotos[employeeName]) {
    return profilePhotos[employeeName];
  }

  // Try lowercase match
  const lowerName = employeeName.toLowerCase();
  if (profilePhotos[lowerName]) {
    return profilePhotos[lowerName];
  }

  // Try first name match
  const firstName = employeeName.split(' ')[0];
  if (profilePhotos[firstName]) {
    return profilePhotos[firstName];
  }

  // Try first name lowercase
  const firstNameLower = firstName.toLowerCase();
  if (profilePhotos[firstNameLower]) {
    return profilePhotos[firstNameLower];
  }

  return null;
};

// Employee Card Component
function EmployeeCard({ employee, rank }: { employee: any; rank: number }) {
  const employeeName = employee.sales_agent || employee.name || 'Unknown';
  const employeePhoto = getProfilePhoto(employeeName);

  // Parse numeric values
  const policies = typeof employee.policies_sold === 'string' 
    ? parseInt(employee.policies_sold.replace(/[^0-9]/g, '')) || 0
    : employee.policies_sold || 0;
  
  const brokerFeeTotal = typeof employee.broker_fee_total === 'string'
    ? parseFloat(employee.broker_fee_total.replace(/[$,]/g, '')) || 0
    : employee.broker_fee_total || 0;
  
  const brokerFeeAverage = typeof employee.broker_fee_average === 'string'
    ? parseFloat(employee.broker_fee_average.replace(/[$,]/g, '')) || 0
    : employee.broker_fee_average || 0;

  const bfAverage = brokerFeeAverage; // alias for clarity with new UI

  const roadsides = employee.roadsides || 0;
  
  const renters = typeof employee.renters === 'string'
    ? parseInt(employee.renters.replace(/[^0-9]/g, '')) || 0
    : employee.renters || 0;

  return (
    <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="flex items-center space-x-4 mb-4">
        <div className="w-16 h-16 rounded-full flex items-center justify-center overflow-hidden bg-blue-100">
          {employeePhoto ? (
            <img
              src={employeePhoto}
              alt={employeeName}
              className="w-full h-full object-cover"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.innerHTML = `<i class="ri-user-line text-blue-600 text-xl"></i>`;
                }
              }}
            />
          ) : (
            <i className="ri-user-line text-blue-600 text-xl"></i>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold truncate text-gray-900">
            {employeeName}
          </h3>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600 flex items-center">
            📋 Policies:
          </span>
          <span className="text-lg font-bold text-gray-900">{policies}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600 flex items-center">
            📈 BF Average:
          </span>
          <span className="text-lg font-bold text-gray-900 flex items-center">
            {bfAverage < 130 && <span className="mr-1">💩</span>}
            ${bfAverage}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600 flex items-center">
            💰 BF Total:
          </span>
          <span className="text-lg font-bold text-gray-900">${brokerFeeTotal.toLocaleString()}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600 flex items-center">
            🚗 Roadsides:
          </span>
          <span className="text-lg font-bold text-gray-900">{roadsides}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-600 flex items-center">
            🏠 Renters:
          </span>
          <span className="text-lg font-bold text-gray-900">{renters}</span>
        </div>
      </div>
    </div>
  );
}

// Ranking Table Component (true table format)
function RankingTable({ employees }: { employees: any[] }) {
  // Create comprehensive ranking data
  const createComprehensiveRanking = (employees: any[]) => {
    return [...employees]
      .filter(emp => emp.sales_agent !== 'Total')
      .map(emp => {
        const policies = typeof emp.policies_sold === 'string' 
          ? parseInt(emp.policies_sold.replace(/[^0-9]/g, '')) || 0
          : emp.policies_sold || 0;
        
        const brokerFeeAverage = typeof emp.broker_fee_average === 'string'
          ? parseFloat(emp.broker_fee_average.replace(/[$,]/g, '')) || 0
          : emp.broker_fee_average || 0;

        const roadsides = emp.roadsides || 0;

        return {
          name: emp.sales_agent || emp.name || 'Unknown',
          policies,
          brokerFeeAverage,
          roadsides,
          photo: getProfilePhoto(emp.sales_agent || emp.name || 'Unknown')
        };
      })
      .sort((a, b) => {
        // Primary sort: Policies (descending)
        if (b.policies !== a.policies) return b.policies - a.policies;
        // Secondary sort: Roadsides (descending)
        if (b.roadsides !== a.roadsides) return b.roadsides - a.roadsides;
        // Tertiary sort: Broker Fee Average (descending)
        return b.brokerFeeAverage - a.brokerFeeAverage;
      });
  };

  const rankedEmployees = createComprehensiveRanking(employees);

  const getRankIcon = (rank: number) => {
    if (rank === 1) return '🏆';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return null;
  };

  const maxPolicies = Math.max(...rankedEmployees.map((e) => e.policies), 1);

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 bg-white border-b border-gray-200">
        <h3 className="text-base font-bold text-gray-900">Performance Rankings</h3>
        <p className="text-xs text-gray-600 mt-1">Ranked by: 1) Policy Count, 2) Roadside, 3) BF Average</p>
        <p className="text-xs text-blue-600 font-medium mt-1">
          Showing {rankedEmployees.length} employees
        </p>
      </div>

      {/* List Items */}
      <div className="divide-y divide-gray-200">
        {rankedEmployees.map((employee, index) => {
          const rank = index + 1;
          const isTopThree = rank <= 3;
          const rankIcon = getRankIcon(rank);
          
          return (
            <div 
              key={index}
              className={`px-4 py-3 ${isTopThree ? 'bg-yellow-50' : 'bg-white'}`}
            >
              {/* Agent Info Row */}
              <div className="flex items-center mb-2">
                {/* Rank Badge */}
                <div className="flex-shrink-0 mr-2">
                  {rankIcon ? (
                    <span className="text-xl">{rankIcon}</span>
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                      <span className="text-xs font-bold text-blue-600">{rank}</span>
                    </div>
                  )}
                </div>

                {/* Avatar */}
                <div className="flex-shrink-0 mr-3">
                  <img
                    className="h-10 w-10 rounded-full object-cover"
                    src={employee.photo || 'https://ui-avatars.com/api/?name=Agent&background=3b82f6&color=ffffff&size=128'}
                    alt={employee.name}
                  />
                </div>

                {/* Name */}
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-gray-900">
                    {employee.name}
                  </div>
                </div>
              </div>

              {/* Metrics Row */}
              <div className="flex items-center justify-end space-x-4 text-xs">
                {/* Policies */}
                <div className="flex items-center">
                  <i className="ri-file-text-fill text-blue-500 mr-1"></i>
                  <span className="font-medium text-gray-900">{employee.policies}</span>
                </div>

                {/* Roadsides */}
                <div className="flex items-center">
                  <i className="ri-roadster-fill text-red-500 mr-1"></i>
                  <span className="font-medium text-gray-900">{employee.roadsides}</span>
                </div>

                {/* BF Average */}
                <div className="flex items-center">
                  <i className="ri-money-dollar-box-fill text-green-500 mr-1"></i>
                  <span className="font-medium text-gray-900">${employee.brokerFeeAverage}</span>
                </div>
              </div>

              {/* Progress Bar */}
              <div className="mt-2">
                <div className="w-full bg-gray-200 rounded-full h-1.5">
                  <div
                    className={`h-1.5 rounded-full ${
                      rank === 1 ? 'bg-yellow-400' :
                      rank === 2 ? 'bg-gray-400' :
                      rank === 3 ? 'bg-orange-400' :
                      'bg-blue-400'
                    }`}
                    style={{
                      width: `${(employee.policies / maxPolicies) * 100}%`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Export default component
export default function MTDSales() {
  const { user } = useAuth();

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');
  const [stats, setStats] = useState({
    totalPoliciesSold: 0,
    totalRoadsides: 0,
    avgBrokerFee: 0,
    agentCount: 0,
    totalRenters: 0
  });

  // Fetch MTD sales data from Supabase
  const fetchMTDSalesData = async () => {
    try {
      setLoading(true);
      setError('');

      const { data: mtdData, error: dbError } = await supabase
        .from('mtd_sales_data')
        .select('*')
        .order('id', { ascending: true });

      if (dbError) {
        console.error('Database error:', dbError);
        throw new Error('Failed to fetch MTD sales data');
      }

      if (!mtdData || mtdData.length === 0) {
        setData([]);
        setStats({
          totalPoliciesSold: 0,
          totalRoadsides: 0,
          avgBrokerFee: 0,
          agentCount: 0,
          totalRenters: 0
        });
        return;
      }

      // Set raw data for tables and cards
      setData(mtdData);

      // Compute stats from the total row and individual agents
      const totalRow = mtdData.find(row => row.sales_agent === 'Total');
      const employees = mtdData.filter(row => row.sales_agent !== 'Total');

      const totalPoliciesSold = totalRow
        ? parseFloat((totalRow.policies_sold || '0').replace(/[^0-9]/g, '')) || 0
        : 0;

      // Get total roadsides from Total row, or calculate from individual agents if not available
      const totalRoadsides = totalRow && totalRow.roadsides !== null && totalRow.roadsides !== undefined
        ? totalRow.roadsides
        : employees.reduce((sum, emp) => sum + (emp.roadsides || 0), 0);

      const avgBrokerFee = totalRow
        ? parseFloat((totalRow.broker_fee_average || '0').replace(/[$,]/g, '')) || 0
        : 0;

      // Calculate total renters from all employees
      const totalRenters = employees.reduce((sum, emp) => {
        const renters = typeof emp.renters === 'string'
          ? parseInt(emp.renters.replace(/[^0-9]/g, '')) || 0
          : emp.renters || 0;
        return sum + renters;
      }, 0);

      setStats({
        totalPoliciesSold,
        totalRoadsides,
        avgBrokerFee,
        agentCount: employees.length,
        totalRenters
      });

      console.log('MTD Sales Data loaded:', {
        totalPoliciesSold,
        totalRoadsides,
        avgBrokerFee,
        agentCount: employees.length,
        totalRenters
      });

    } catch (err) {
      console.error('Error in fetchMTDSalesData:', err);
      setError(err instanceof Error ? err.message : 'Unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  // Alias for header refresh
  const handleRefresh = fetchMTDSalesData;

  useEffect(() => {
    // Always fetch data, don't wait for user
    fetchMTDSalesData();
  }, []);

  // Check if user is administrator
  const isAdmin = user?.email && [
    'carlos@driveninsurance.com',
    'andrew@driveninsurance.com', 
    'pj@driveninsurance.com'
  ].includes(user.email.toLowerCase());

  // Calculate top performers from employee data
  const employees = data.filter(row => row.sales_agent !== 'Total');
  
  // Find top performers
  const topPolicies = employees.length > 0 ? employees.reduce((prev, current) => {
    const prevPolicies = typeof prev.policies_sold === 'string' 
      ? parseInt(prev.policies_sold.replace(/[^0-9]/g, '')) || 0
      : prev.policies_sold || 0;
    const currentPolicies = typeof current.policies_sold === 'string'
      ? parseInt(current.policies_sold.replace(/[^0-9]/g, '')) || 0
      : current.policies_sold || 0;
    return currentPolicies > prevPolicies ? current : prev;
  }) : null;

  const topRoadsides = employees.length > 0 ? employees.reduce((prev, current) => {
    // Convert roadside values to numbers for proper comparison
    const prevRoadsides = typeof prev.roadsides === 'string' 
      ? parseInt(prev.roadsides.replace(/[^0-9]/g, '')) || 0
      : prev.roadsides || 0;
    const currentRoadsides = typeof current.roadsides === 'string'
      ? parseInt(current.roadsides.replace(/[^0-9]/g, '')) || 0
      : current.roadsides || 0;
    return currentRoadsides > prevRoadsides ? current : prev;
  }) : null;

  const topBrokerFeeTotal = employees.length > 0 ? employees.reduce((prev, current) => {
    const prevBrokerFeeTotal = typeof prev.broker_fee_total === 'string'
      ? parseFloat(prev.broker_fee_total.replace(/[$,]/g, '')) || 0
      : prev.broker_fee_total || 0;
    const currentBrokerFeeTotal = typeof current.broker_fee_total === 'string'
      ? parseFloat(current.broker_fee_total.replace(/[$,]/g, '')) || 0
      : current.broker_fee_total || 0;
    return currentBrokerFeeTotal > prevBrokerFeeTotal ? current : prev;
  }) : null;

  // Transform top performers data for display
  const topPoliciesData = topPolicies ? {
    name: topPolicies.sales_agent || topPolicies.name || 'Unknown',
    policies: typeof topPolicies.policies_sold === 'string' 
      ? parseInt(topPolicies.policies_sold.replace(/[^0-9]/g, '')) || 0
      : topPolicies.policies_sold || 0,
    photo: getProfilePhoto(topPolicies.sales_agent || topPolicies.name || 'Unknown')
  } : null;

  const topRoadsidesData = topRoadsides ? {
    name: topRoadsides.sales_agent || topRoadsides.name || 'Unknown',
    roadsides: typeof topRoadsides.roadsides === 'string'
      ? parseInt(topRoadsides.roadsides.replace(/[^0-9]/g, '')) || 0
      : topRoadsides.roadsides || 0,
    photo: getProfilePhoto(topRoadsides.sales_agent || topRoadsides.name || 'Unknown')
  } : null;

  const topBrokerFeeTotalData = topBrokerFeeTotal ? {
    name: topBrokerFeeTotal.sales_agent || topBrokerFeeTotal.name || 'Unknown',
    brokerFeeTotal: typeof topBrokerFeeTotal.broker_fee_total === 'string'
      ? parseFloat(topBrokerFeeTotal.broker_fee_total.replace(/[$,]/g, '')) || 0
      : topBrokerFeeTotal.broker_fee_total || 0,
    photo: getProfilePhoto(topBrokerFeeTotal.sales_agent || topBrokerFeeTotal.name || 'Unknown')
  } : null;

  // Create employee cards data sorted alphabetically
  const employeeCardsData = employees
    .map((emp, index) => ({
      ...emp,
      id: index + 1
    }))
    .sort((a, b) => {
      const nameA = (a.sales_agent || a.name || 'Unknown').toLowerCase();
      const nameB = (b.sales_agent || b.name || 'Unknown').toLowerCase();
      return nameA.localeCompare(nameB);
    });

  if (loading) {
    return (
      <div className="min-h-screen bg-green-400">
        <Header 
          onRefresh={handleRefresh} 
          isConnected={!error} 
          showDashboardButton={isAdmin} 
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <i className="ri-loader-4-line animate-spin text-4xl text-blue-600 mb-4"></i>
              <p className="text-gray-600">Loading MTD sales data...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-green-400">
        <Header 
          onRefresh={handleRefresh} 
          isConnected={!error} 
          showDashboardButton={isAdmin} 
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <i className="ri-error-warning-line text-4xl text-red-600 mb-4"></i>
              <p className="text-red-600 mb-4">{error}</p>
              <button
                onClick={fetchMTDSalesData}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 hover:shadow-lg hover:-translate-y-1 transition-colors"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-green-400">
      <Header 
        onRefresh={handleRefresh} 
        isConnected={!error} 
        showDashboardButton={isAdmin} 
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Title */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">MTD Sales Dashboard</h1>
          <p className="text-gray-600 mt-2">Month-to-date sales performance and employee rankings</p>
        </div>

        {/* Quick Actions */}
        <div className="mb-8">
          <div className="flex flex-col lg:flex-row justify-center items-center mb-6 space-y-4 lg:space-y-0">
            <div className="flex-shrink-0 flex flex-wrap justify-center gap-3 max-w-6xl">
              <Link
                to="/philippines-sales"
                className="flex-1 min-w-[140px] max-w-[180px] px-4 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-2"
              >
                <i className="ri-bar-chart-line"></i>
                <span>PH Sales MTD</span>
              </Link>

              <Link
                to="/philippines-sales-today"
                className="flex-1 min-w-[140px] max-w-[180px] px-4 py-3 bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-2"
              >
                <i className="ri-calendar-line"></i>
                <span>PH Sales Today</span>
              </Link>
              
              {/* Only show Dashboard button for administrators */}
              {isAdmin && (
                <Link
                  to="/dashboard"
                  className="flex-1 min-w-[140px] max-w-[180px] px-4 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-2"
                >
                  <i className="ri-dashboard-line"></i>
                  <span>Dashboard</span>
                </Link>
              )}
              
              <Link
                to="/todays-sales"
                className="flex-1 min-w-[140px] max-w-[180px] px-4 py-3 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-2"
              >
                <i className="ri-calendar-todo-line"></i>
                <span>Today's Sales</span>
              </Link>

              <Link
                to="/retention-mtd"
                className="flex-1 min-w-[140px] max-w-[180px] px-4 py-3 bg-sky-500 text-white rounded-lg font-medium hover:bg-sky-600 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-2"
              >
                <i className="ri-user-heart-line"></i>
                <span>Retention MTD</span>
              </Link>

              <Link
                to="/retention-today"
                className="flex-1 min-w-[140px] max-w-[180px] px-4 py-3 bg-sky-500 text-white rounded-lg font-medium hover:bg-sky-600 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-2"
              >
                <i className="ri-user-heart-line"></i>
                <span>Retention Today</span>
              </Link>

              <Link
                to="/employee-dashboard"
                className="flex-1 min-w-[140px] max-w-[180px] px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex items-center justify-center space-x-2 border-2 border-blue-3"
              >
                <i className="ri-user-line"></i>
                <span>Employee Dashboard</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
          <StatsCard
            title="Total Policies Sold"
            value={stats.totalPoliciesSold.toString()}
            icon="ri-file-list-3-line"
            color="blue"
          />
          <StatsCard
            title="Total Renters"
            value={stats.totalRenters.toString()}
            icon="ri-home-line"
            color="teal"
          />
          <StatsCard
            title="Total Roadsides"
            value={stats.totalRoadsides.toString()}
            icon="ri-roadster-line"
            color="green"
          />
          <StatsCard
            title="Average Broker Fee"
            value={`$${Math.round(stats.avgBrokerFee)}`}
            icon="ri-bar-chart-line"
            color="purple"
          />
          <StatsCard
            title="Number of Agents"
            value={stats.agentCount.toString()}
            icon="ri-team-line"
            color="indigo"
          />
        </div>

        {/* Top Performers Highlight Cards */}
        {topPoliciesData && topRoadsidesData && topBrokerFeeTotalData && (
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-trophy-line text-yellow-500 mr-2"></i>
              Top Performers
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Most Policies */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-200 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-16 h-16 rounded-full flex items-center justify-center overflow-hidden bg-blue-200 shadow-md">
                    {topPoliciesData.photo ? (
                      <img
                        src={topPoliciesData.photo}
                        alt={topPoliciesData.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.style.display = 'none';
                          const parent = target.parentElement;
                          if (parent) {
                            parent.innerHTML = `<i class="ri-user-line text-blue-600 text-xl"></i>`;
                          }
                        }}
                      />
                    ) : (
                      <i className="ri-user-line text-blue-600 text-xl"></i>
                    )}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-1">
                      <i className="ri-trophy-fill text-yellow-500 text-lg"></i>
                      <span className="text-sm font-medium text-blue-700">Most Policies</span>
                    </div>
                    <h3 className="text-lg font-bold text-blue-900">{topPoliciesData.name}</h3>
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-700 mb-1">{topPoliciesData.policies}</div>
                  <div className="text-sm text-blue-600 font-medium">Policies Sold</div>
                </div>
              </div>

              {/* Most Roadsides */}
              <div className="bg-gradient-to-br from-green-50 to-green-100 border-2 border-green-200 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-16 h-16 rounded-full flex items-center justify-center overflow-hidden bg-green-200 shadow-md">
                    {topRoadsidesData.photo ? (
                      <img
                        src={topRoadsidesData.photo}
                        alt={topRoadsidesData.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.style.display = 'none';
                          const parent = target.parentElement;
                          if (parent) {
                            parent.innerHTML = `<i className="ri-user-line text-green-600 text-xl"></i>`;
                          }
                        }}
                      />
                    ) : (
                      <i className="ri-user-line text-green-600 text-xl"></i>
                    )}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-1">
                      <i className="ri-trophy-fill text-yellow-500 text-lg"></i>
                      <span className="text-sm font-medium text-green-700">Most Roadsides</span>
                    </div>
                    <h3 className="text-lg font-bold text-green-900">{topRoadsidesData.name}</h3>
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-700 mb-1">{topRoadsidesData.roadsides}</div>
                  <div className="text-sm text-green-600 font-medium">Roadside Sales</div>
                </div>
              </div>

              {/* Highest Broker Fee Total */}
              <div className="bg-gradient-to-br from-purple-50 to-purple-100 border-2 border-purple-200 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-16 h-16 rounded-full flex items-center justify-center overflow-hidden bg-purple-200 shadow-md">
                    {topBrokerFeeTotalData.photo ? (
                      <img
                        src={topBrokerFeeTotalData.photo}
                        alt={topBrokerFeeTotalData.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.style.display = 'none';
                          const parent = target.parentElement;
                          if (parent) {
                            parent.innerHTML = `<i class="ri-user-line text-purple-600 text-xl"></i>`;
                          }
                        }}
                      />
                    ) : (
                      <i className="ri-user-line text-purple-600 text-xl"></i>
                    )}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-1">
                      <i className="ri-trophy-fill text-yellow-500 text-lg"></i>
                      <span className="text-sm font-medium text-purple-700">Highest BF Total</span>
                    </div>
                    <h3 className="text-lg font-bold text-purple-900">{topBrokerFeeTotalData.name}</h3>
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-purple-700 mb-1">${topBrokerFeeTotalData.brokerFeeTotal.toLocaleString()}</div>
                  <div className="text-sm text-purple-600 font-medium">Broker Fee Total</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Individual Employee Performance Cards - ALPHABETICALLY ORDERED */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Individual Employee Performance</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {employeeCardsData.map((employee, index) => (
              <EmployeeCard
                key={employee.id || index}
                employee={employee}
                rank={index + 1} // This rank is just for display, not based on performance
              />
            ))}
          </div>
        </div>

        {/* Performance Rankings - PERFORMANCE ORDERED */}
        <div className="mb-8">
          <RankingTable employees={data} />
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-4 mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-gray-500">
            © 2013 Driven Insurance Services. All rights reserved. V2.0
          </p>
        </div>
      </footer>
    </div>
  );
}
